'use strict'

const md5 = require('md5')
const AccessPolicy = require('./lib/access-policy')
const Action = require('./lib/action')
const Authorizer = require('./lib/authorizer')
const AuthorizerError = require('./lib/error')
const FeaturePolicy = require('./lib/feature-policy')
const resolvePolicy = require('./lib/resolver').resolvePolicy

const cache = {}

module.exports = {
    AccessDeniedError: AuthorizerError.AccessDeniedError,
    AccessPolicy,
    Action,
    create(policy) {
        const hash = md5(JSON.stringify(policy))
        if (!(hash in cache)) {
            cache[hash] = new Authorizer(policy)
        }
        return cache[hash]
    },
    FeaturePolicy,
    resolvePolicy,
    sessionKey: 'osprey-session'
}



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/index.js
// module id = 290
// module chunks = 51